import { render, staticRenderFns } from "./ArenaUnit.vue?vue&type=template&id=7b642c42&scoped=true&"
import script from "./ArenaUnit.vue?vue&type=script&lang=js&"
export * from "./ArenaUnit.vue?vue&type=script&lang=js&"
import style0 from "./ArenaUnit.vue?vue&type=style&index=0&id=7b642c42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b642c42",
  null
  
)

export default component.exports